import React, { useContext, useMemo, useRef, useState } from 'react'
import { CannedResponseTemplate, getResponseOfContentType } from '../../../../../../../models/axiosModel';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Divider, Grid, TextField, Typography } from '@mui/material';
import style from "../../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import chatStyles from "../../../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../../../assets/styles/global.module.scss";
import feedbackStyles from "../../../../../../../assets/styles/componentStyles/feedbackDialog.module.scss"
import GlobalButton from '../../../../../../../components/utility/globalButton/button';
import Required from '../../../../../../../components/utility/required';
import UploadIcon from '@mui/icons-material/Upload';
import { UserContext, UserContextPayload } from '../../../../../../../context/userContext';
import { getFileTypeImgIcon, getWhatsappMediaSizeLimit } from '../../../../../../../utils/constants';
import DeleteIcon from '@mui/icons-material/Delete';
import agent from '../../../../../../../services/api';
import { DragDropContext, Droppable, Draggable, DropResult } from 'react-beautiful-dnd';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useRuleBasedInboxStore } from '../../../../../../../store/ruleBasedInboxStore';
import { useShallow } from 'zustand/react/shallow';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { useInsertVariableAtCursorPosition } from '../../../../../../../hooks/useInsertVariableAtCursorPosition';
import { useGenericStore } from '../../../../../../../store/genericStore';
import { CANNED_RESPONSE_VARIABLES, emptycannedResponseMessage, emptyCannedResVariable, fileType } from '../../../../../constants';
import { extractFileNameFromUrl } from '../../../../../utils';
import { renderMediaMsg } from '../../../../../renderUtils';

interface CannedResponseEditPopupProps {
    setFlagCannedResDetailPopup: React.Dispatch<React.SetStateAction<boolean>>,
    contentTypeData: getResponseOfContentType[] | null,
    getCannedResponseApi: (canned_response_template_id: string | null, flagDirectSend: boolean, flagToUpdate?: React.Dispatch<React.SetStateAction<boolean>>) => Promise<void>,
}

interface fileInputData {
    index: number,
    content_type_name: string,
    accept: string,
}

const CannedResponseEditPopup: React.FC<CannedResponseEditPopupProps> = (props) => {

    const { contentTypeData, getCannedResponseApi, setFlagCannedResDetailPopup } = props;
    const hiddenFileInput = useRef<HTMLInputElement | null>(null);
    const [fileInputData, setFileInputData] = useState<fileInputData>({
        index: -1,
        content_type_name: "",
        accept: "",
    })

    const [files, setFiles] = useState<any>([]);
    const scrollRef = useRef<HTMLDivElement>(null);
    const [expandedAccordions, setExpandedAccordions] = useState<{ [key: number]: boolean }>({});

    const { cannedResponseList, setCurrentCannedRes, currentCannedRes, onChangeOfCannedResMsg } = useRuleBasedInboxStore(useShallow((store) => ({
        cannedResponseList: store.cannedResponseList,
        setCurrentCannedRes: store.setCurrentCannedRes,
        currentCannedRes: store.currentCannedRes as CannedResponseTemplate,
        onChangeOfCannedResMsg: store.onChangeOfCannedResMsg,
    })))

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const { registerTextarea, insertVariable } = useInsertVariableAtCursorPosition();

    const { setFlagLoading, flagLoading, handleError } = useContext(UserContext) as UserContextPayload

    const uploadFileHandler = async (e: any, fileType: string, index: number) => {
        const file: any = e.target.files[0];
        if (file) {
            if ((file?.size / 1048576) > getWhatsappMediaSizeLimit(fileType)) {
                return;
            }

            setFiles((prev: any) => {
                if (!prev) return [file];
                return [...prev, file];
            })

            let formData = new FormData()
            formData.append(
                "file", file, file.name,
            )
            formData.append("chatbot_flag", "true");
            formData.append("private_file_flag", "false");

            setFlagLoading({ ...flagLoading, flagRoundLoader: true })
            await agent.uploadFile.post(formData).then(async (res) => {
                if (res.status) {
                    file.isUploading = false;
                    file.file_data = res.data.data;

                    file.google_storage_id = res.data.data.google_storage_id;
                    await setFiles((old: any) => {
                        let temp = [...old]
                        let fileType = file.name.split('.').pop()
                        let fileTypeIconSrc = getFileTypeImgIcon(fileType) ?? ""
                        temp.map((rr: any) => {
                            if (rr.google_storage_id == file.google_storage_id) {
                                rr.isUploading = false;
                                rr.file_data = res.data.data;
                                rr.google_storage_id = res.data.data.google_storage_id;
                                rr.previewImageSrc = fileTypeIconSrc;
                            }
                        })
                        return temp
                    })

                    let updatedCurrentCannedRes = currentCannedRes;
                    updatedCurrentCannedRes = {
                        ...updatedCurrentCannedRes,
                        canned_response_messages: updatedCurrentCannedRes?.canned_response_messages?.map((message, ind) => {
                            if (ind == index) {
                                return {
                                    ...message,
                                    message_url: res.data.data?.file_path,
                                }
                            }
                            return message;
                        })
                    }
                    setCurrentCannedRes(updatedCurrentCannedRes);

                    let images = [];
                    for (let i = 0; i < e.target.files.length; i++) {
                        images.push(URL.createObjectURL(e.target.files[i]))
                    }
                }
            }).catch((err) => {
                showError("Something went wrong!")
                setFiles([])
                console.error(err)
            });

            setFlagLoading({ ...flagLoading, flagRoundLoader: false })
        }
    }

    const removeFileHandler = async (url: string) => {
        const storageId = files?.find((file: any) => file?.file_data?.file_path == url)?.file_data?.google_storage_id;
        if (storageId) {
            await agent.removeUploadedFile.delete(storageId).then(async (res) => {
                if (res.data.status) {
                    setFiles((prev: any) => {
                        return prev.filter((file: any) => {
                            return file?.file_data?.file_path != url;
                        })
                    });
                } else {
                    handleError(res.data);
                }
            }).catch((err) => {
                console.log(err);
            })
        }
        const inputEl = document.getElementById("image") as HTMLInputElement;
        if (inputEl) inputEl.value = "";
    }

    const checkDisabledCreateBtn = () => {
        if(flagDuplicateCannedResponse) {
            return true;
        }
        if (currentCannedRes?.template_title?.trim()?.length > 0) {
            return !currentCannedRes?.canned_response_messages?.every((msg) => {
                if (msg?.content_type?.name?.length > 0) {
                    const contentType = msg?.content_type?.name?.toLowerCase();
                    switch (contentType) {
                        case "text":
                            return msg?.message_content?.trim()?.length > 0;
                        case "image":
                        case "video":
                        case "document":
                            return msg?.message_url?.length > 0;
                        default:
                            return false;
                    }
                } else return false;
            })
        }
        return true;
    }

    const handleCreateCannedResApi = async () => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        let payload = currentCannedRes;
        payload.canned_response_messages = payload.canned_response_messages.map((message, index) => {
            const variablesUsed = CANNED_RESPONSE_VARIABLES.filter((variable) => message.message_content?.includes(`{{${variable.key}}}`)).map((variable) => ({
                ...emptyCannedResVariable,
                variable_key: variable.key,
                ...(currentCannedRes.canned_response_template_id && {
                    canned_response_variable_id: message?.canned_response_variables?.find((vars) => vars.variable_key == variable.key)?.canned_response_variable_id || null,
                })
            }));
            return {
                ...message,
                message_sequence: index + 1,
                canned_response_variables: variablesUsed,
            };
        });
        const res = await agent.manageCannedResponse.post(payload);
        if (!(res.status)) {
            handleError(res);
        } else {
            showSuccess(`Canned Response ${payload.canned_response_template_id ? "Updated" : "Created"} Successfully.`)
            await getCannedResponseApi(null, false);
            setFlagCannedResDetailPopup(false);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const handleCancelClick = () => {
        setFlagCannedResDetailPopup(false);
    }

    const handleAddMessageClick = () => {
        let updatedCurrentCannedRes = currentCannedRes;
        updatedCurrentCannedRes = {
            ...updatedCurrentCannedRes,
            canned_response_messages: [...updatedCurrentCannedRes?.canned_response_messages, { ...emptycannedResponseMessage, message_sequence: currentCannedRes?.canned_response_messages?.length + 1 }],
        }

        setCurrentCannedRes(updatedCurrentCannedRes);
        setTimeout(() => {
            scrollRef?.current?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    }

    const handleDragEnd = (result: DropResult) => {
        const { source, destination } = result;
        if (!destination) return;

        const reordered = Array.from(currentCannedRes?.canned_response_messages || []);
        const [removed] = reordered.splice(source.index, 1);
        reordered.splice(destination.index, 0, removed);

        let updatedCurrentCannedRes = currentCannedRes;
        updatedCurrentCannedRes = {
            ...updatedCurrentCannedRes,
            canned_response_messages: reordered
        }

        setCurrentCannedRes(updatedCurrentCannedRes);
    };

    const flagDuplicateCannedResponse = useMemo(() => {
        let cannedResList = cannedResponseList;
        if(currentCannedRes?.canned_response_template_id) {
            cannedResList = cannedResList?.filter((cannedRes) => cannedRes?.canned_response_template_id !== currentCannedRes?.canned_response_template_id) ?? [];
        }
        return cannedResList?.some((cannedRes) => cannedRes?.template_title?.trim() == currentCannedRes?.template_title?.trim()) ?? false;
    }, [currentCannedRes?.template_title])

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={style.popupTitleTypography}>
                                {`${currentCannedRes?.canned_response_template_id ? 'Update' : 'Create'} Canned Response`}
                            </Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />

                        <Grid item>
                            <Grid container className={style.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={style.popupFieldTypography}>Canned Response Title <Required /></Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                value={currentCannedRes?.template_title}
                                                onChange={(e) => {
                                                    let updatedCurrentCannedRes = currentCannedRes;
                                                    updatedCurrentCannedRes = {
                                                        ...updatedCurrentCannedRes,
                                                        template_title: e.target.value,
                                                    }

                                                    setCurrentCannedRes(updatedCurrentCannedRes);
                                                }}
                                                placeholder='Enter Canned Response Title'
                                                className={`${style.campaignContactPopupTextField} ${globalStyles.fullwidth}`}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />

                        <input
                            ref={hiddenFileInput}
                            id="image"
                            type="file"
                            className={`file-inputs ${chatStyles.fileUploadIconInput}`}
                            accept={fileInputData?.accept}
                            onChange={(e) => {
                                uploadFileHandler(e, fileInputData?.content_type_name, fileInputData?.index); 
                                (e.target as HTMLInputElement).value = null as unknown as string;
                            }}
                        ></input>

                        <Grid item>
                            <Grid container className={`${chatStyles.cannedResponseGridContainer} ${chatStyles.cannedResponseMessagesContainerMaxHeight}`} direction={"column"}>
                                <div className={`${globalStyles.overflowAuto} ${flagDuplicateCannedResponse ? chatStyles.cannedResMaxHeightWithWarning : chatStyles.cannedResMaxHeight }`}>
                                    <DragDropContext
                                        onDragEnd={handleDragEnd}
                                        onDragStart={() => { }}
                                    >
                                        <Droppable droppableId="cannedResponseMessages">
                                            {(provided) => (
                                                <div {...provided.droppableProps} ref={provided.innerRef}>
                                                    {currentCannedRes?.canned_response_messages?.map((message, index) => {
                                                        return (
                                                            <Draggable
                                                                key={index}
                                                                draggableId={index.toString()}
                                                                index={index}
                                                            >
                                                                {(provided, snapshot) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        style={{
                                                                            ...provided.draggableProps.style,
                                                                            marginBottom: '8px',
                                                                            // background: snapshot.isDragging ? '#f0f0f0' : 'transparent',
                                                                            borderRadius: '4px',
                                                                        }}
                                                                    >
                                                                        <Grid item xs={12}>
                                                                            <Grid container className={`${globalStyles.spaceAlignmentCenter} ${globalStyles.containerFlexWrap}`}>
                                                                                {currentCannedRes?.canned_response_messages?.length > 1 &&
                                                                                    <Grid item {...provided.dragHandleProps} className={`${chatStyles.cannedResponseDragDropIcon}`}>
                                                                                        <DragIndicatorIcon className={chatStyles.dragIndicatorIcon} />
                                                                                    </Grid>
                                                                                }
                                                                                <Grid item xs={12}>
                                                                                    <Accordion
                                                                                        defaultExpanded
                                                                                        expanded={currentCannedRes?.canned_response_messages?.length == 1 ? true : (snapshot.isDragging) ? false : !expandedAccordions[index]}
                                                                                        // expanded={currentCannedRes?.canned_response_messages?.length == 1 ? true : !expandedAccordions[index]}
                                                                                        className={`${chatStyles.agentAccordion} ${chatStyles.cannedResponseAccordion}`}
                                                                                    >
                                                                                        <AccordionSummary
                                                                                            expandIcon={currentCannedRes?.canned_response_messages?.length == 1 ? <></> : <ExpandMoreIcon />}
                                                                                            aria-controls="panel1-content"
                                                                                            id="panel1-header"
                                                                                            className={`${chatStyles.cannedResponseccordionSummary}`}
                                                                                            onClick={() => {
                                                                                                if (!snapshot.isDragging) {
                                                                                                    setExpandedAccordions(prev => ({
                                                                                                        ...prev,
                                                                                                        [index]: !prev[index],
                                                                                                    }));
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            <Typography className={chatStyles.cannedResponseMessageTypo}>{`Message ${index + 1}`}</Typography>
                                                                                        </AccordionSummary>
                                                                                        <AccordionDetails className={currentCannedRes?.canned_response_messages?.length == 1 ? chatStyles.cannedResponseAccordionDetailsForOneItem : chatStyles.cannedResponseAccordionDetails}>
                                                                                            <Grid container gap={"10px"}>
                                                                                                <Grid item xs={12}>
                                                                                                    <Grid container gap={"12px"} ref={(index == currentCannedRes?.canned_response_messages?.length - 1) ? scrollRef : null}>
                                                                                                        <Grid item xs={12}>
                                                                                                            <Grid container className={`${globalStyles.alignItemCenter} ${globalStyles.spaceAlignmentCenter}`}>
                                                                                                                <Grid item>
                                                                                                                    <Typography className={style.popupFieldTypography}>{`Message Content Type`}<Required /></Typography>
                                                                                                                </Grid>
                                                                                                                {currentCannedRes?.canned_response_messages?.length > 1 &&
                                                                                                                    <Grid
                                                                                                                        item
                                                                                                                        onClick={() => {
                                                                                                                            if (message?.message_url) {
                                                                                                                                removeFileHandler(message?.message_url);
                                                                                                                            }
                                                                                                                            let updatedCurrentCannedRes = currentCannedRes;
                                                                                                                            updatedCurrentCannedRes = {
                                                                                                                                ...updatedCurrentCannedRes,
                                                                                                                                canned_response_messages: updatedCurrentCannedRes?.canned_response_messages?.filter((msg, ind) => index != ind),
                                                                                                                            }

                                                                                                                            setCurrentCannedRes(updatedCurrentCannedRes);
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <DeleteIcon className={chatStyles.cannedRedActionBtn} />
                                                                                                                    </Grid>
                                                                                                                }
                                                                                                            </Grid>
                                                                                                        </Grid>
                                                                                                        <Grid item xs={12}>
                                                                                                            <Autocomplete
                                                                                                                className={`${style.contactFilterDropdownsInPopup}`}
                                                                                                                options={contentTypeData || []}
                                                                                                                getOptionLabel={(option: getResponseOfContentType) => option.content_type_name || ""}
                                                                                                                value={contentTypeData?.find((type) => type.content_type_id == message?.content_type?.id) || null}
                                                                                                                renderInput={(params) => <TextField {...params} placeholder='Select Message Content Type' />}
                                                                                                                onChange={(_, value: getResponseOfContentType | null) => {
                                                                                                                    if (message?.message_url) {
                                                                                                                        removeFileHandler(message?.message_url);
                                                                                                                    }
                                                                                                                    let updatedCurrentCannedRes = currentCannedRes;
                                                                                                                    updatedCurrentCannedRes = {
                                                                                                                        ...updatedCurrentCannedRes,
                                                                                                                        canned_response_messages: updatedCurrentCannedRes?.canned_response_messages?.map((msg, ind) => {
                                                                                                                            if (ind == index) {
                                                                                                                                return {
                                                                                                                                    ...msg,
                                                                                                                                    content_type_id: value ? value.content_type_id : 0,
                                                                                                                                    message_url: "",
                                                                                                                                    content_type: value ? { id: value?.content_type_id, name: value?.content_type_name } : { id: 0, name: "" }
                                                                                                                                }
                                                                                                                            }
                                                                                                                            return msg;
                                                                                                                        })
                                                                                                                    }

                                                                                                                    setCurrentCannedRes(updatedCurrentCannedRes);
                                                                                                                }}
                                                                                                            />
                                                                                                        </Grid>
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                                {message?.content_type?.name?.length > 0 &&
                                                                                                    <>
                                                                                                        <Grid item xs={12}>
                                                                                                            <Grid container gap={"12px"}>
                                                                                                                <Grid item xs={12}>
                                                                                                                    <Typography className={style.popupFieldTypography}>Message Content {message?.content_type?.name?.toLowerCase() == "text" && <Required />}</Typography>
                                                                                                                </Grid>
                                                                                                                <Grid item xs={12}>
                                                                                                                    <textarea
                                                                                                                        rows={3}
                                                                                                                        placeholder={`Enter Message Content`}
                                                                                                                        className={`${feedbackStyles.longTextFeedbackInputField} ${chatStyles.cannedResponseMessageTextarea}`}
                                                                                                                        ref={(el) => registerTextarea(index, el)}
                                                                                                                        value={message?.message_content}
                                                                                                                        onChange={(e) => {
                                                                                                                            onChangeOfCannedResMsg(e.target.value, index);
                                                                                                                        }}
                                                                                                                    />
                                                                                                                </Grid>
                                                                                                            </Grid>
                                                                                                        </Grid>
                                                                                                        <Grid item xs={12}>
                                                                                                            <Grid container className={`${globalStyles.displayFlexStyle} ${globalStyles.flexColumn}`} gap={2}>
                                                                                                                <Grid item>
                                                                                                                    <Grid container gap={"15px"}>
                                                                                                                        {CANNED_RESPONSE_VARIABLES?.map((variable) => {
                                                                                                                            return (
                                                                                                                                <Grid item>
                                                                                                                                    <Typography
                                                                                                                                        className={chatStyles.cannedResVariable}
                                                                                                                                        onMouseDown={(e) => e.preventDefault()}
                                                                                                                                        onClick={() => {
                                                                                                                                            const messageContentAfterVariableInsert = insertVariable(variable?.key ?? '', index, currentCannedRes?.canned_response_messages?.[index]?.message_content ?? '');
                                                                                                                                            onChangeOfCannedResMsg(messageContentAfterVariableInsert, index);
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        {variable?.label}
                                                                                                                                    </Typography>
                                                                                                                                </Grid>
                                                                                                                            );
                                                                                                                        })}
                                                                                                                    </Grid>
                                                                                                                </Grid>
                                                                                                                <Grid item>
                                                                                                                    {message?.content_type?.name?.toLowerCase() != "text" &&
                                                                                                                        <GlobalButton
                                                                                                                            buttonText={`Add ${message?.content_type?.name}`}
                                                                                                                            className='borderedButtonStyle'
                                                                                                                            startIcon={<UploadIcon />}
                                                                                                                            onClick={() => {
                                                                                                                                setFileInputData({
                                                                                                                                    index: index,
                                                                                                                                    content_type_name: message?.content_type?.name,
                                                                                                                                    accept: fileType?.find((file) => file?.label?.toLowerCase() == message?.content_type?.name?.toLowerCase())?.acceptedFileType || "",
                                                                                                                                });
                                                                                                                                setTimeout(() => hiddenFileInput?.current?.click(), 0);
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    }
                                                                                                                </Grid>
                                                                                                            </Grid>
                                                                                                        </Grid>
                                                                                                        {message?.message_url &&
                                                                                                            <Grid item xs={12} className={`${globalStyles.displayFlexStyle}`}>
                                                                                                                {renderMediaMsg(message?.content_type?.name?.toLowerCase(), message?.message_url, "", extractFileNameFromUrl(message?.message_url), true)}
                                                                                                            </Grid>
                                                                                                        }
                                                                                                    </>
                                                                                                }
                                                                                            </Grid>
                                                                                        </AccordionDetails>
                                                                                    </Accordion>
                                                                                    {(index != currentCannedRes?.canned_response_messages?.length - 1) &&
                                                                                        <Grid item xs={12}>
                                                                                            <Divider />
                                                                                        </Grid>
                                                                                    }
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        );
                                                    })}

                                                </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </div>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container className={`${chatStyles.addMessageContainer} ${globalStyles.displayFlexStyle} ${globalStyles.flexColumn}`} gap={1}>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Add Message"
                                        className='primaryButtonStyle'
                                        onClick={() => {
                                            handleAddMessageClick();
                                        }}
                                        disabled={currentCannedRes?.canned_response_messages?.length >= 10}
                                    />
                                </Grid>
                                {flagDuplicateCannedResponse && 
                                    <Grid item>
                                        <Grid container className={`${chatStyles.duplicateCannedResWarningGrid}`} gap={1}>
                                            <Grid item className={globalStyles.displayFlexStyle}>
                                                <ErrorOutlineOutlinedIcon className={chatStyles.duplicateCannedResWarningIcon} />
                                            </Grid>
                                            <Grid item>
                                                <Typography className={`${chatStyles.duplicateCannedResWarningTitle} ${globalStyles.tertiaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                                    A canned response with this title already exists. Please enter a unique title.
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                        <Grid item className={`${globalStyles.displayFlexStyle} ${globalStyles.justifyCenter} ${chatStyles.cannedResponseFooterBtn}`}>
                            <Grid container className={`${globalStyles.justifyCenter} ${globalStyles.alignItemCenter} ${chatStyles.cannedResponseFooterBtnContainer}`}>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Cancel"
                                        className='borderedButtonStyle'
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        onClick={() => {
                                            handleCancelClick();
                                        }}
                                    />
                                </Grid>
                                <Grid item>
                                    <GlobalButton
                                        buttonText={currentCannedRes?.canned_response_template_id ? 'Update' : 'Create'}
                                        className='primaryButtonStyle'
                                        disabled={checkDisabledCreateBtn()}
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        onClick={() => {
                                            handleCreateCannedResApi();
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CannedResponseEditPopup
